document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.card__add-to-cart');

  buttons.forEach(button => {
    button.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const btn = this;
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const result = await response.json();

        if (result.status && result.status !== 200) {
          throw new Error(result.description || 'Fehler');
        }

        // Gesamtwarenkorb abrufen, damit Header aktualisiert wird
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.open();

        // Visuelles Feedback: kurz grün mit Häkchen
        const originalHTML = btn.innerHTML;
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';
        btn.style.color = '#2a9d3c';

        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.style.color = '';
          btn.disabled = false;
        }, 1500);

      } catch (err) {
        console.error('Add to cart error', err);
        btn.disabled = false;

        const originalHTML = btn.innerHTML;
        btn.innerHTML = '!';
        btn.style.color = '#c0392b';
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.style.color = '';
        }, 1500);
      }
    });
  });
});
